import React, { PureComponent } from 'react';
import { addTranslation, IntlProps } from '../../../../../decorators/addTranslation';
import { BaseFilledFields } from '../types';

interface Props extends IntlProps {
  baseFields: BaseFilledFields;
}

class GeneralInfoPreview extends PureComponent<Props> {
  render() {
    const { getTranslate, baseFields } = this.props;
    const { amount, currency, projectId, paymentMethodUrlAlias, extraParam }: BaseFilledFields = baseFields;

    return (
      <ul>
        <li className="ui-form-fields__item utils-flex ui-form-fields__item--preview">
          <span>{getTranslate('payouts.request.single.projectLabel')}:</span>
          <span>{projectId.value}</span>
        </li>
        <li className="ui-form-fields__item utils-flex ui-form-fields__item--preview">
          <span>{getTranslate('payouts.request.single.methodLabel')}:</span>
          <span>{paymentMethodUrlAlias.value}</span>
        </li>
        <li className="ui-form-fields__item utils-flex ui-form-fields__item--preview">
          <span>{getTranslate('payouts.request.single.amountLabel')}:</span>
          <span>{amount}</span>
        </li>
        <li className="ui-form-fields__item utils-flex ui-form-fields__item--preview">
          <span>{getTranslate('payouts.request.single.currency')}:</span>
          <span>{currency}</span>
        </li>
        <li className="ui-form-fields__item utils-flex ui-form-fields__item--preview">
          <span>{getTranslate('payouts.request.single.extraParamLabel')}:</span>
          <span>{extraParam}</span>
        </li>
      </ul>
    );
  }
}

export default addTranslation(GeneralInfoPreview);